<template>
  <b-card
    v-if="data"
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Statistics</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in data"
          :key="item.icon"
          xl="3"
          sm="6"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="65"
                :variant="item.color"
              >
                <feather-icon
                  size="32"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <p class="font-weight-bolder mb-0">
                <div class="d-flex h3">
                    {{ item.title }} 
                    <!-- <feather-icon
                        :icon="data.upDown > 0 ? 'ArrowUpIcon':'ArrowDownIcon'"
                        :class="data.upDown > 0 ? 'text-success':'text-danger'"
                        class="mb-25 ml-25"
                    /> -->
                </div>
                <b-card-text class="font-small-5 mb-0">
                    {{ item.subtitle }} <b-spinner v-if="loading" class="align-middle mr-1 my-2" variant="secondary"></b-spinner>
                </b-card-text>
              </p>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BSpinner, BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import * as Services from './services'
export default {
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  setup() {
    const { Views, Visitor, PCC } = Services
    const { data: dataVisitor } = Visitor()
    const { data: dataViews } = Views()
    const { data: dataPCC } = PCC()

    
    return {
      dataViews,
      dataVisitor,
      dataPCC,
      loading : true
    }
  },
  computed: {
    data() {
      let countPartisipants = 0
      this.dataPCC.forEach(element => {
        countPartisipants += element.participants_count
      });
      return [
          {
              color: 'success',
              icon: 'TrendingUpIcon',
              title: this.dataViews,
              subtitle: 'Views'
          },
          {
              color: 'primary',
              icon: 'UserIcon',
              title: this.dataVisitor,
              subtitle: 'Visitors'
          },
          {
              color: 'warning',
              icon: 'BoxIcon',
              title: this.dataPCC.length,
              subtitle: 'PCC'
          },
          {
              color: 'secondary',
              icon: 'UsersIcon',
              title: countPartisipants,
              subtitle: 'Participants'
          },
      ]
    }
  },
  watch: {
    dataVisitor: function (newVal, oldVal) {
      this.loading = false
    }
  }
}
</script>
